import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgZorroAntdModule } from '../utilities/ng-zorro-antd.module';
import { ReportsListComponent } from './reports-list.component';
import { ReportsRoutingModule } from './reports.routing.module';
import {MomentModule} from 'ngx-moment';
import { TransactionsComponent } from './transactions/transactions.component';
import { SettlementsComponent } from './settlements/settlements.component';
import { DownloadService } from './download-service';
import { MerchantDailySummaryComponent } from './merchant-daily-summary/merchant-daily-summary.component';
import { ViewDetailsModule } from '../view-details/view-details.module';
import { ViewReceiptsModule } from '../view-receipts/view-receipts.module';

@NgModule({
    imports: [
        ReportsRoutingModule,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgZorroAntdModule,
        MomentModule,
        ViewDetailsModule,
        ViewReceiptsModule
    ],
    // tslint:disable-next-line: max-line-length
    declarations: [ReportsListComponent, TransactionsComponent, SettlementsComponent, MerchantDailySummaryComponent],
    exports: [ReportsListComponent],
    providers: [DownloadService]
})
  export class ReportsModule {
  }
